export const defaultBrand = {
  name: 'Premiere Plumbing',
  shortName: 'PP',
  primary: '#173e36',
  primaryStrong: '#102d27',
  accent: '#dfff73',
  logoUrl: ''
};

export function applyTenantBranding(branding = defaultBrand) {
  const root = document.documentElement;
  root.style.setProperty('--brand-primary', branding.primary || defaultBrand.primary);
  root.style.setProperty('--brand-primary-strong', branding.primaryStrong || defaultBrand.primaryStrong);
  root.style.setProperty('--brand-accent', branding.accent || defaultBrand.accent);
}